import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { S as StatusDot } from "./StatusDot.js";
import styles from "./components/ListHeader/styles.module.scss";
const ListHeaderText = (props) => {
  const {
    firstText,
    firstTextEmphasised = false,
    secondText = void 0,
    secondTextEmphasised = false,
    subText = false,
    statusDotVariant,
    className = "",
    testId,
    titleHtmlMarkup = "span"
  } = props;
  const headerTextWrapperClasses = classNames(className, styles["text-wrapper"], {
    [styles["text-wrapper--sub-level"]]: subText
  });
  const firstHeaderTextSegmentClasses = classNames({
    [styles["text-wrapper__text--emphasised"]]: firstTextEmphasised
  });
  const secondHeaderTextSegmentClasses = classNames({
    [styles["text-wrapper__text--emphasised"]]: secondTextEmphasised
  });
  const CustomTag = titleHtmlMarkup;
  return /* @__PURE__ */ jsxs("span", { "data-testid": testId, className: headerTextWrapperClasses, children: [
    statusDotVariant !== void 0 && /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(StatusDot, { text: "", variant: statusDotVariant }) }),
    /* @__PURE__ */ jsxs(CustomTag, { className: styles["list-header__title"], children: [
      /* @__PURE__ */ jsx("span", { className: firstHeaderTextSegmentClasses, children: firstText }),
      secondText && /* @__PURE__ */ jsx("span", { className: secondHeaderTextSegmentClasses, children: secondText })
    ] })
  ] });
};
ListHeaderText.displayName = "ListHeaderText";
export {
  ListHeaderText as L
};
//# sourceMappingURL=ListHeaderText.js.map
